import { render, staticRenderFns } from "./sell-in-period-field.vue?vue&type=template&id=2ab4895e&scoped=true"
import script from "./sell-in-period-field.vue?vue&type=script&lang=js"
export * from "./sell-in-period-field.vue?vue&type=script&lang=js"
import style0 from "./sell-in-period-field.vue?vue&type=style&index=0&id=2ab4895e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab4895e",
  null
  
)

export default component.exports